import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input
} from '@angular/core';

import { CardBodyComponent } from './components/card-body.component';
import { CardFooterComponent } from './components/card-footer.component';
import { CardHeaderComponent } from './components/card-header.component';

@Component({
  selector: 'ls-cr-card',
  templateUrl: './cirrus-card.component.html',
  styleUrls: ['./cirrus-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CirrusCardComponent {
  @Input() public large = false;

  @ContentChild(CardHeaderComponent) public header: CardHeaderComponent;
  @ContentChild(CardBodyComponent) public body: CardBodyComponent;
  @ContentChild(CardFooterComponent) public footer: CardFooterComponent;
}
